import { render, staticRenderFns } from "./DialogGeneric.vue?vue&type=template&id=67dd99d4"
import script from "./DialogGeneric.vue?vue&type=script&lang=ts"
export * from "./DialogGeneric.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports